import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout für CMS-Seiten-Unterseiten (/website/$pageId/*) */
export const Route = createFileRoute('/_authenticated/website/$pageId')({
  component: () => <Outlet />,
});
